import React from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import ContainerMax from "components/shared/ContainerMax"
import Carousel from "./Carousel"
import { media } from "utils/Media"

const Arrow = styled.div`
    display: none;
    cursor: pointer;
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    text-transform: uppercase;
    color: white;
    text-align: center;
    z-index: 50;

    @media ${media.md} {
        display: block;
    }
`

const HeroCarousel = (props) => {
    const { arrowText } = props.block

    const scrollToDiv = () => {

        const header = document.getElementById('siteHeader')
        let headerHeight = 0
        if (header) {
            headerHeight = header.offsetHeight
        }

        const id = "hero-bottom";
        const yOffset = -headerHeight;
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    
        window.scrollTo({ top: y, behavior: "smooth" });
     };

    return (
        <ContainerMax maxWidth="1920" noPadding className="position-relative">
            <Carousel slides={props.block.slides} />
            {/* {arrowText && (
                <Arrow
                    className={`hidden md:block cursor-pointer absolute left-1/2 bottom-5 -translate-x-1/2 uppercase text-white text-center text-xl z-50`}
                    onClick={scrollToDiv}
                >
                    {arrowText}
                    <br />
                    <FontAwesomeIcon icon={faAngleDown} className="max-w-[15px]" bounce />
                </Arrow>
            )} */}
            <div id="hero-bottom"></div>
        </ContainerMax>
    )
}

export default HeroCarousel